import { PageActionType } from './page-action-type';

export interface LoadPageRequestAction {
  pageKey: string;
  type: PageActionType.LoadPageRequest;
}

export const loadPageRequest = (pageKey: string): LoadPageRequestAction => ({
  pageKey,
  type: PageActionType.LoadPageRequest,
});
